import { YoutubeItemTypes } from "../../components/YoutubeSlider/types";
import YoutubeSlider from "../../components/YoutubeSlider/YoutubeSlider";
import { RoutePattern } from "../../routes/RoutePattern";

const data: YoutubeItemTypes[] = [
  {
    title: "SAINt JHN - High Integrity (Official Music Video)",
    videoId: "c96wXY1SwCE",
  },
  {
    title: "SAINt JHN - Body On Me",
    videoId: "c-QlUwphGI8",
  },
  {
    title: "SAINt JHN - Circles",
    videoId: "teXioGnM0-0",
  },
  {
    title: `SAINt JHN - "Sucks To Be You" (Official Music Video)`,
    videoId: "hmMPB9U_QMU",
  },
  {
    title: `SAINt JHN - "Roses" Remix ft. Future (Official Music Video)`,
    videoId: "PMM-zuwIVS4",
  },
];

export default function Videos() {
  return (
    <div
      id={RoutePattern.VIDEOS}
      className="w-full md:min-h-screen flex flex-col justify-center items-center pb-[100px] md:pb-0"
    >
      <h2 className="section-heading">VIDEOS</h2>
      <div className="mt-[--space-btw-sections] w-full">
        <YoutubeSlider data={data} />
      </div>
    </div>
  );
}
